import { gql } from 'apollo-boost';

const deleteHardwareGQL = gql`
  mutation hardware($id: String!) {
    deleteHardware(id: $id)
  }
`;

export default deleteHardwareGQL;
